import dayjs from 'dayjs';
import intl from 'react-intl-universal';

/**
 * 格式化相对时间（包含国际化文案，属于业务展示逻辑）
 * @param date 日期字符串或 Date 对象
 * @returns 相对时间描述
 */
export function formatRelativeTime(date: string | Date): string {
  const now = dayjs();
  const targetDate = dayjs(date);
  const diffMinutes = now.diff(targetDate, 'minute');
  const diffHours = now.diff(targetDate, 'hour');
  const diffDays = now.diff(targetDate, 'day');

  if (diffMinutes < 1) {
    return intl.get('common.time.justNow');
  } else if (diffMinutes < 60) {
    return intl.get('common.time.minutesAgo', { count: diffMinutes });
  } else if (diffHours < 24) {
    return intl.get('common.time.hoursAgo', { count: diffHours });
  } else if (diffDays < 7) {
    return intl.get('common.time.daysAgo', { count: diffDays });
  } else {
    // 对于超过 7 天的日期，使用统一的日期格式
    return targetDate.format('YYYY/MM/DD');
  }
}
